import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  colspan: "headers.length"
}
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_edit_dialog = _resolveComponent("v-edit-dialog")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createBlock(_component_v_data_table, {
    headers: _ctx.monthHeader,
    items: _ctx.budgetDetails,
    "item-key": "item.title",
    class: "elevation-1 table",
    "hide-default-footer": true
  }, {
    item: _withCtx((props) => [
      (!props.item.isTotal)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
            _createElementVNode("td", _hoisted_2, [
              (props.item.editable)
                ? (_openBlock(), _createBlock(_component_v_edit_dialog, {
                    key: 0,
                    "return-value": props.item.title,
                    "onUpdate:returnValue": ($event: any) => ((props.item.title) = $event)
                  }, {
                    input: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        modelValue: props.item.title,
                        "onUpdate:modelValue": ($event: any) => ((props.item.title) = $event),
                        "single-line": ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.item.title) + " ", 1)
                    ]),
                    _: 2
                  }, 1032, ["return-value", "onUpdate:returnValue"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.item.title), 1))
            ]),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], (month) => {
              return _createElementVNode("td", {
                key: month,
                class: "text-left"
              }, [
                (props.item.editable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_ctx.displayMenu[props.item.title + ' ' + month] === false)
                        ? (_openBlock(), _createElementBlock("span", {
                            style: _normalizeStyle(
                                props.item.budget[month].hasBeenManuallyModified
                                    ? 'color:orange'
                                    : ''
                            ),
                            key: _ctx.keyRefresh,
                            onClick: ($event: any) => {
                                _ctx.displayMenu[props.item.title + ' ' + month] = true;
                                _ctx.keyRefresh++;
                            }
                          }, _toDisplayString(props.item.budget[month].amountSigned), 13, _hoisted_5))
                        : (_openBlock(), _createBlock(_component_v_menu, {
                            "close-on-click": false,
                            "close-on-content-click": false,
                            key: _ctx.keyRefresh,
                            modelValue: _ctx.displayMenu[props.item.title + ' ' + month],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.displayMenu[props.item.title + ' ' + month]) = $event)
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createElementVNode("span", _mergeProps({
                                style: 
                                        props.item.budget[month].hasBeenManuallyModified
                                            ? 'color:orange'
                                            : ''
                                    ,
                                ref_for: true
                              }, props), _toDisplayString(props.item.budget[month].amountSigned), 17)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, { class: "d-flex pa-0 ma-0 elevation-0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_oss_text_field, {
                                    outlined: "",
                                    dense: "",
                                    "single-line": "",
                                    class: "d-flex my-2 mr-2 float-left align-end",
                                    "hide-details": "",
                                    onChange: ($event: any) => (_ctx.updateData(props.item, month)),
                                    modelValue: props.item.budget[month].amountSigned,
                                    "onUpdate:modelValue": ($event: any) => ((props.item.budget[month].amountSigned) = $event)
                                  }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_icon, _mergeProps({
                                        class: "d-flex mt-2",
                                        onClick: ($event: any) => {
                                                _ctx.displayMenu[props.item.title + ' ' + month] = false;
                                                _ctx.keyRefresh++;
                                            },
                                        size: "small",
                                        location: "end",
                                        ref_for: true
                                      }, props), {
                                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                                          _createTextVNode("$oss-circle-check ")
                                        ])),
                                        _: 2
                                      }, 1040, ["onClick"])
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[2] || (_cache[2] = _createElementVNode("span", null, "Valider", -1))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_icon, _mergeProps({
                                        class: "d-flex mt-2",
                                        onClick: ($event: any) => (_ctx.duplicateRightAll(props.item, month)),
                                        size: "small",
                                        location: "end",
                                        ref_for: true
                                      }, props), {
                                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                                          _createTextVNode("$oss-duplicate ")
                                        ])),
                                        _: 2
                                      }, 1040, ["onClick"])
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[4] || (_cache[4] = _createElementVNode("span", null, "Dupliquer sur les cellules de droite", -1))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"]))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(props.item.budget[month].amountSigned), 1))
              ])
            }), 64)),
            _createElementVNode("td", null, [
              _createVNode(_component_v_icon, {
                disabled: props.index < 3,
                onClick: ($event: any) => (_ctx.deleteLine(props.index)),
                size: "small"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" $oss-trash ")
                ])),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      (props.item.isTotal)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
            _createElementVNode("td", _hoisted_8, _toDisplayString(props.item.title), 1),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], (month) => {
              return _createElementVNode("td", {
                key: props.item.budget[month].date,
                class: "text-left"
              }, _toDisplayString(props.item.budget[month].amountSigned), 1)
            }), 64)),
            _createElementVNode("td", null, [
              _createVNode(_component_v_icon, {
                disabled: props.index < 3,
                onClick: ($event: any) => (_ctx.deleteLine(props.index)),
                size: "small"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode(" $oss-trash ")
                ])),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    [`body.append`]: _withCtx(({ columns }) => [
      _createElementVNode("tr", null, [
        _createElementVNode("td", {
          colspan: columns.length - 1
        }, [
          _createVNode(_component_v_btn, {
            rounded: "circle",
            elevation: "0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addBlankLine())),
            size: "small"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" + ")
            ])),
            _: 1
          })
        ], 8, _hoisted_9)
      ])
    ]),
    _: 2
  }, 1032, ["headers", "items"]))
}